module.exports = __webpack_public_path__ + "static/img/indexPic5.86560be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic5.png
// module id = hd6m
// module chunks = 1